import {
  UserCleaningRecapPeriodsDto,
  UserCleaningRecap,
} from "@typings/userCleaningRecap";

const periodsFactory = (
  payload: UserCleaningRecapPeriodsDto,
): UserCleaningRecap => {
  const { years } = payload;
  const recap: UserCleaningRecap = {};

  years.forEach(year => {
    const { year: yearNumber, months } = year;

    recap[yearNumber] = months.map(month => month.month);
  });

  return recap;
};

export { periodsFactory };
